import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

// This is an especially custom icon: size is 46x24. Be careful with
// how / where this is used to ensure it renders as expected.
export const PrivatePlentyAccount: FC<IconSVGComponentProps> = ({
    ...props
}) => {
    return (
        <IconSVG viewBox="0 0 46 24" {...props}>
            <path
                d="M7.09695 16.673C8.41256 15.2776 10.1987 14.42 12.1661 14.42C14.1335 14.42 15.9197 15.2776 17.2353 16.673M14.7007 9.63249C14.7007 11.0323 13.5659 12.1671 12.1661 12.1671C10.7663 12.1671 9.63153 11.0323 9.63153 9.63249C9.63153 8.23267 10.7663 7.0979 12.1661 7.0979C13.5659 7.0979 14.7007 8.23267 14.7007 9.63249Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.5704 3.60065C18.3924 1.37864 15.3572 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C15.3572 24 18.3924 22.6214 20.5704 20.3993C20.28 19.9706 20.0113 19.526 19.7658 19.0671C17.8453 21.1762 15.0772 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C15.0772 1.5 17.8453 2.82376 19.7658 4.93289C20.0113 4.47403 20.28 4.02943 20.5704 3.60065Z"
                fill="currentColor"
                strokeWidth="0"
                stroke="none"
            />
            <circle
                cx="33"
                cy="12"
                r="11.25"
                stroke="#4B657E"
                strokeWidth="1.5"
            />
            <path
                d="M35.9167 9.83333V8.66667C35.9167 7.05584 34.6108 5.75 33 5.75C31.3892 5.75 30.0833 7.05584 30.0833 8.66667V9.83333M33 12.4583V13.625M31.1333 16.25H34.8667C35.8468 16.25 36.3368 16.25 36.7111 16.0593C37.0404 15.8915 37.3081 15.6238 37.4759 15.2945C37.6667 14.9201 37.6667 14.4301 37.6667 13.45V12.6333C37.6667 11.6532 37.6667 11.1632 37.4759 10.7888C37.3081 10.4596 37.0404 10.1919 36.7111 10.0241C36.3368 9.83333 35.8468 9.83333 34.8667 9.83333H31.1333C30.1532 9.83333 29.6632 9.83333 29.2888 10.0241C28.9596 10.1919 28.6918 10.4596 28.5241 10.7888C28.3333 11.1632 28.3333 11.6532 28.3333 12.6333V13.45C28.3333 14.4301 28.3333 14.9201 28.5241 15.2945C28.6918 15.6238 28.9596 15.8915 29.2888 16.0593C29.6632 16.25 30.1532 16.25 31.1333 16.25Z"
                stroke="#4B657E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </IconSVG>
    );
};
